export default __webpack_public_path__ + "static/media/under-construction.20eb4719.svg";